<template>

<div class="keyword-search">
  <form class="input-wrap" @submit.prevent='submitKeywordForm'>
    <input type="text" v-model="keywordQuery" @keyup="emitKeyword" placeholder="Keyword search..." id='keyword-query'/>
    <button type="submit">
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 16C9.77498 15.9996 11.4988 15.4054 12.897 14.312L17.293 18.708L18.707 17.294L14.311 12.898C15.405 11.4997 15.9996 9.77544 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16ZM8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2Z" fill="#676868"/>
      </svg>
    </button>
  </form>
</div>

</template>

<script>
import {axiosClient} from "@/axios-client";

 export default {
   data() {
     return {
       keywordQuery: '',
     }
   },

   props: ['searchParams'],

   methods: {
     submitKeywordForm() {
      let keyword = this.keywordQuery;
      this.$store.commit('resultsAreLoading')

       axiosClient.post('v1/search/registrations',
        {
         keywordQuery: keyword,
         productName: this.searchParams.productName,
         productCategory: this.searchParams.productCategory,
         manufacturerName: this.searchParams.manufacturerName,
         specialty: this.searchParams.specialty,
         riskLevel: this.searchParams.riskLevel,
         sources: this.searchParams.sources
        })
        .then((response) => {
          const registrations = response.data.records || response.data
          this.$emit('searched', registrations);
          this.$store.commit('resultsLoaded');
        })
        // .then((response) => console.log(response.data))
        .catch((err) => console.log(err));
     },

     emitKeyword() {
       let value = document.querySelector('#keyword-query').value;
       this.$emit('keyword', value);
     }
   },
 }
</script>

<style lang="scss">
  .input-wrap {
    padding: 7px;
    background: #fff;
    border: 1px solid #ededed;
    box-shadow: 0 4px 15px rgba(51, 51, 51, 0.03);
    border-radius: 15px;
    width: 480px;
    // margin: 40px auto 15px auto;
    margin: 0 auto;
    display: flex;
    align-items: center;

    input {
      background: none;
      border: none;
      width: 100%;
      padding-left: 20px;

      &:focus {
        outline: none;
      }
    }

    button {
      border: none;
      padding: 14px;
      background: #f9f9f9;
      border-radius: 9px;
      
      &:focus {
        outline: none;
      }
    }
  }
</style>